<template>
    <div :style="cssPropsFields" class="fields-container">
        <template v-for="field in fields">
            <template v-if="field.active">
                <booking-input 
                    v-if="inputType[field.value] == 'input'"
                    :attributes="attributes"
                    :config="field"
                    :icon="icons.rate"
                    :booking_data="booking_data"
                    :class_width="classWidth[field.width]" 
                ></booking-input>
                <booking-input-date 
                    v-if="inputType[field.value] == 'date'"
                    v-show="inputType[field.value] == 'date' &&  template !== 'fixed'"
                    :attributes="attributes"
                    :config="field"
                    :startDate="startDate"
                    :endDate="endDate"
                    :icon="icons.calendar"
                    :booking_data="booking_data"
                    :class_width="classWidth[field.width]"
                ></booking-input-date>
                <booking-select
                    v-if="checkInputSelect(field)" 
                    :attributes="attributes"
                    :config="field"
                    :icon="icons.select"
                    :booking_data="booking_data"
                    :class_width="classWidth[field.width]"
                ></booking-select>
                <booking-guest
                    v-if="field.value === 'adults' && shouldShowSelectGuest"
                    :attributes="attributes"
                    :config="field"
                    :icon="icons.select"
                    :fields="getNestedFields"
                    :booking_data="booking_data"
                    :backgroundColor="backgroundColor"
                    :class_width="classWidth[field.width]"
                ></booking-guest>
            </template>
        </template>
    </div>
    
</template>

<script>

    import BookingInput from './BookingInput.vue';
    import BookingSelect from './BookingSelect.vue';
    import BookingInputDate from './BookingInputDate.vue'
    import BookingGuest from './BookingGuest.vue';

    export default{
        name: 'BookingFields',
        components:{
            BookingInput,
            BookingSelect,
            BookingInputDate,
            BookingGuest
        },
        props:{
            config: Object,
            startDate: String,
            endDate: String,
            icons: Object,
            booking_data: Object,
            template: String,
            backgroundColor: String
        },
        methods:{
            checkInputSelect( field ){
                if(this.inputType[field.value] == 'select'){
                    if( field.value === 'rooms'  ){
                        return true
                    }

                    if( field.value !== 'rooms' && 
                        this.shouldShowSelectAdultsAndChildren
                    ){
                        return false
                    }else{
                        return true
                    }
                }
                return false
            }
           
        },
        data(){
            return{
                fields: this.config.children,
                // field: {},
                attributes: this.config.attributes,
                inputType: {
                    dates: 'date',
                    rooms: 'select',
                    adults: 'select',
                    children: 'select',
                    promo: 'input',
                    rate: 'input',
                    group: 'input'
                },
                classWidth: {
                    '100%': 'col-12',
                    '50%': 'col-6',
                    '30%': 'col-3',
                    '15%': 'col-2'
                }
            }
        },
        computed:{
            cssPropsIcons(){
              
            },
            cssPropsFields(){
                return {
                    '--color-select-option' : this.backgroundColor,
                }
            },
            adultsAndChildrenAreActive(){
                let bothActive = true
                for (const property in this.fields) {
                     const field = this.fields[property]
                     if( (field.value === 'adults' || field.value === 'children') && !field.active ){
                        bothActive = false
                    }
                }
                return bothActive
            },
            getNestedFields(){
                let fieldChildren = {}
                let fieldAdults = {}
                for (const property in this.fields) {
                    const field = this.fields[property]
                    if( field.value === 'adults'){
                        fieldAdults = field
                    }
                    if( field.value === 'children'){
                        fieldChildren = field
                    }
                }
                return {
                    children: fieldChildren,
                    adults: fieldAdults
                }
            },

            shouldShowSelectAdultsAndChildren(){
                let values = {
                    adults: false,
                    children:false,
                    merge_adults_children: false
                }
                for (const property in this.fields) {
                    const field = this.fields[property]
                    if(field.value === 'adults'){
                        values = {
                            ...values,
                            adults: field.active,
                            merge_adults_children: field.merge_adults_children
                        }
                    }
                    if(field.value === 'children'){
                        values = {
                            ...values,
                            children: field.active,
                        }
                    }
                }
                if(this.template === 'fixed' && values.adults && values.children){
                    return true
                }

                if(this.template !== 'fixed' && values.merge_adults_children && values.children){
                    return true
                }

                return false
            },

            shouldShowSelectGuest(){
                let values = {
                    adults: false,
                    children:false,
                    merge_adults_children: false
                }
                for (const property in this.fields) {
                    const field = this.fields[property]
                    if(field.value === 'adults'){
                        values = {
                            ...values,
                            adults: field.active,
                            merge_adults_children: field.merge_adults_children
                        }
                    }
                    if(field.value === 'children'){
                        values = {
                            ...values,
                            children: field.active,
                        }
                    }
                }
                if(this.template === 'fixed' && values.adults && values.children){
                    return true
                }

                if(this.template !== 'fixed' && values.merge_adults_children && values.children){
                    return true
                }

                return false
            }

        },
        mounted(){
            if( this.attributes['label-inside'] ){
                const { padding , fontSizeLabelInside } = this.attributes
                const paddings = padding.split(' ')
                const fontSize = Number(paddings[0].split('px')[0])
                document.querySelectorAll('.field-container input , .field-container select').forEach((input , index) =>{
                  
                    input.addEventListener('focus' , function(){
                        this.previousElementSibling.style.fontSize = fontSizeLabelInside
                        this.previousElementSibling.style.top = '4px'
                    })

                })
            }
        }
    }

</script>

<style lang="scss">
    .field-container{
        display: inline-block;
        margin: 10px 1% 10px 1%;
        // margin: 10px 0;
        select{
            background-repeat: no-repeat;
            background-position: 95% center;
            width: 100%;
            option{
                text-align: left;
                color: var(--color-select-option);
            }
        }
        input{
            background-repeat: no-repeat;
            background-position: 95% center;
            width: 100%;
        }
        &.col-12 {
            width: 97%;
        }
        &.col-6{
            width: 47%;
        }
        &.col-3{
            width: 30.3%;
        }
        &.col-2{
            width: 16.5%;
        }
        &.col-9{
            width: 66%;
        }
       
    }
</style>